export const onClientEntry = () => {
  // Use runtime require in Gatsby browser entry to avoid path-alias resolution issues here.
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
  const { clearGoogleAnalyticsCookies } = require("./src/utils/clearGoogleAnalyticsCookies");
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
  const { applyAffiseTrackingFromUrl } = require("./src/utils/applyAffiseTrackingFromUrl");
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
  const { syncPageLayoutBodyAttribute } = require("./src/utils/urlUtils");

  syncPageLayoutBodyAttribute();
  clearGoogleAnalyticsCookies();
  applyAffiseTrackingFromUrl();
};

export const onRouteUpdate = () => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
  const { applyAffiseTrackingFromUrl } = require("./src/utils/applyAffiseTrackingFromUrl");
  // eslint-disable-next-line @typescript-eslint/no-var-requires, global-require
  const { syncPageLayoutBodyAttribute } = require("./src/utils/urlUtils");

  syncPageLayoutBodyAttribute();
  applyAffiseTrackingFromUrl();
};
